export default function setNewCollectionValues(
    originalValues?: string[],
    newValues?: string[]
): string[] {
    if (
        typeof originalValues === 'undefined' ||
        typeof newValues === 'undefined'
    ) {
        return []
    }

    const uniqueNewValues = [...new Set(newValues)]

    const areEqual =
        originalValues.length &&
        originalValues.every((value) => newValues.includes(value))

    if (areEqual) {
        return []
    }

    // remove the new values that are already in the original
    const newValuesFiltered = uniqueNewValues.filter(
        (value: string) => !originalValues.includes(value)
    )
    const originalValuesFiltered = originalValues.filter(
        (value: string) => !uniqueNewValues.includes(value)
    )

    const result = [...originalValuesFiltered, ...newValuesFiltered]

    // remove duplicates
    return [...new Set(result)]
}
